/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeleteCategoryCommand } from '../../models/delete-category-command';
import { DeleteCategoryCommandResult } from '../../models/delete-category-command-result';

export interface ApiNurseryManagerCategoryDeleteCategoryDelete$Params {
      body?: DeleteCategoryCommand
}

export function apiNurseryManagerCategoryDeleteCategoryDelete(http: HttpClient, rootUrl: string, params?: ApiNurseryManagerCategoryDeleteCategoryDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteCategoryCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiNurseryManagerCategoryDeleteCategoryDelete.PATH, 'delete');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeleteCategoryCommandResult>;
    })
  );
}

apiNurseryManagerCategoryDeleteCategoryDelete.PATH = '/api/NurseryManager/Category/DeleteCategory';
